export default __webpack_public_path__ + "static/media/event.0a928c16.png";